import React, { useEffect, useState } from 'react';
import { Tab } from 'react-bootstrap';
import { Tabs } from 'react-bootstrap';
import './companyProfile.css';
import { useDispatch, useSelector } from 'react-redux';
import { getProfileDetails } from '../../store/DashBoard/actions';

const CompanyProfile = () => {

    const isLoggedIn = useSelector(state => state?.sessionState?.role)
    const profileDetails = useSelector(state => state?.dashboardReducer?.profileDetails)

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const params = urlParams.get("isChatboat");

    const dispatch = useDispatch();

    let companyId = localStorage.getItem('companyId')
    useEffect(() => {
        getProfileDetails(companyId)(dispatch)
    }, [])
    
    return (
        <>
            <div className='container my-4'>
                <div className='company-details-wrap'>
                    <div>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item"><a href={isLoggedIn === 'CONSUMER' ? '/consumer_dashboard' : isLoggedIn === 'BANKING' ? "/banking" : "/dashboard"}>Dashboard</a></li>
                            <li className="breadcrumb-item active" aria-current="page">{isLoggedIn === 'CONSUMER' ? 'Generator profile' : isLoggedIn === 'BANKING' ? "Company Profile" : 'Consumer Profile'}</li>
                        </ul>
                    </div>
                    <div className='card-box'>
                        <div className='card-box-body'>
                            <div className='company-profile-details-wrap'>
                                {/* <div className='text-center'><img src='images/com-profile-img-1.png' alt='company profile' /></div> */}
                                <div className='company-profile-rside'>
                                    <h4 className='company-profile-title' style={{ filter: 'blur(5px)' }}>{profileDetails?.name}</h4>
                                    {/* <div className='company-profile-descprition'><h5>Company Description : </h5>&nbsp; <h6 className='mt-1'>{profileDetails?.description}</h6></div> */}
                                    <div className='company-profile-gst'>
                                        <div>TAN - L17XXXXXXXX</div>
                                        <div>GSTIN - 22XXXXXXXXXX</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='custom-nav-tabs card-box mt-4' >
                        <Tabs variant='nav' defaultActiveKey="Details 1" id='company-profile-tab'>
                            <Tab eventKey="Details 1" title='Company Information'>
                                <div className='div-table'>
                                    <div className='div-row'>
                                        <div className='div-cell'>Category</div>
                                        <div className='div-cell'>:</div>
                                        <div className='div-cell div-cell-black'>{profileDetails?.category?.name}</div>
                                    </div>
                                    <div className='div-row'>
                                        <div className='div-cell'>City</div>
                                        <div className='div-cell'>:</div>
                                        <div className='div-cell div-cell-black'>{profileDetails?.addresses?.length>0 ? profileDetails?.addresses[0]?.city : "Vadodara"}</div>
                                    </div>
                                    <div className='div-row'>
                                        <div className='div-cell'>State</div>
                                        <div className='div-cell'>:</div>
                                        <div className='div-cell div-cell-black'>{profileDetails?.addresses?.length>0 ? profileDetails?.addresses[0]?.stateUt : "Gujarat"}</div>
                                    </div>
                                    <div className='div-row'>
                                        <div className='div-cell'>Credit Rating</div>
                                        <div className='div-cell'>:</div>
                                        <div className='div-cell div-cell-black'>{profileDetails?.creditRating?.rating}</div>
                                    </div>
                                    <div className='div-row'>
                                        <div className='div-cell'>Credit Rating Year</div>
                                        <div className='div-cell'>:</div>
                                        <div className='div-cell div-cell-black'>{profileDetails?.creditRatingYear}</div>
                                    </div>
                                    <div className='div-row'>
                                        <div className='div-cell'>Credit Rating Agency</div>
                                        <div className='div-cell'>:</div>
                                        <div className='div-cell div-cell-black'>{profileDetails?.creditRatingAgency}</div>
                                    </div>
                                </div>
                            </Tab>
                            {isLoggedIn === 'CONSUMER' ? <Tab eventKey="Details 2" title={"Plant Details"}>
                                <div className='div-table'>
                                    <div className='div-row'>
                                        <div className='div-cell'>Energy Type</div>
                                        <div className='div-cell'>:</div>
                                        <div className='div-cell div-cell-black'>{profileDetails?.plant?.energyType?.type}</div>
                                    </div>
                                    <div className='div-row'>
                                        <div className='div-cell'>Project Id</div>
                                        <div className='div-cell'>:</div>
                                        <div className='div-cell div-cell-black'>{profileDetails?.plant?.projectId}</div>
                                    </div>
                                    <div className='div-row'>
                                        <div className='div-cell'>Install Capacity</div>
                                        <div className='div-cell'>:</div>
                                        <div className='div-cell div-cell-black'>{profileDetails?.plant?.installedCap}</div>
                                    </div>
                                    <div className='div-row'>
                                        <div className='div-cell'>Control Area</div>
                                        <div className='div-cell'>:</div>
                                        <div className='div-cell div-cell-black'>{profileDetails?.plant?.controlArea?.type}</div>
                                    </div>
                                    <div className='div-row'>
                                        <div className='div-cell'>Point Of Injection</div>
                                        <div className='div-cell'>:</div>
                                        <div className='div-cell div-cell-black'>{profileDetails?.plant?.poi?.value}</div>
                                    </div>
                                    <div className='div-row'>
                                        <div className='div-cell'>Poi Location</div>
                                        <div className='div-cell'>:</div>
                                        <div className='div-cell div-cell-black'>{profileDetails?.plant?.poiLocation}</div>
                                    </div>
                                </div>
                            </Tab> :
                                <Tab eventKey="Details 2" title={'Consumer Details'}>
                                    <div className='div-table'>
                                        <div className='div-row'>
                                            <div className='div-cell'>Specification</div>
                                            <div className='div-cell'>:</div>
                                            <div className='div-cell div-cell-black'>{profileDetails?.consumer?.specification?.name}</div>
                                        </div>
                                        <div className='div-row'>
                                            <div className='div-cell'>Point of Drawal</div>
                                            <div className='div-cell'>:</div>
                                            <div className='div-cell div-cell-black'>{profileDetails?.consumer?.pod?.value}</div>
                                        </div>
                                        <div className='div-row'>
                                            <div className='div-cell'>Banking</div>
                                            <div className='div-cell'>:</div>
                                            <div className='div-cell div-cell-black'>{profileDetails?.consumer?.discom?.acronym}</div>
                                        </div>
                                        <div className='div-row'>
                                            <div className='div-cell'>Banking Voltage Level</div>
                                            <div className='div-cell'>:</div>
                                            <div className='div-cell div-cell-black'>{profileDetails?.consumer?.discom?.voltageLevels}</div>
                                        </div>
                                    </div>
                                </Tab>}
                        </Tabs>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CompanyProfile;
